import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleGetStreakStatus } from "../../api-clients/streaksClient";
import useAuth from "../../hooks/useAuth";

function useStreakStatusQuery() {
  const { isLoggedIn } = useAuth();

  return useQuery({
    queryKey: [QUERY_KEYS.STREAK.STATUS],
    queryFn: handleGetStreakStatus,
    enabled: isLoggedIn,
  });
}

export default useStreakStatusQuery;
